import { render, staticRenderFns } from "./LoanStatusTableFinalRow.vue?vue&type=template&id=ce82bd16&scoped=true&"
var script = {}
import style0 from "./LoanStatusTableFinalRow.vue?vue&type=style&index=0&id=ce82bd16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce82bd16",
  null
  
)

export default component.exports